// extracted by mini-css-extract-plugin
export default {"imageWrapper":"styles_imageWrapper__uwssx","image":"styles_image__IlyAx","dotsWrapper":"styles_dotsWrapper__sNEqP","dot":"styles_dot__NaTy8"};